import { useToggleFlag } from "src/shared/hooks/useToggleFlag"

import "./Wrapper.css"
import { WrapperProps } from "./Wrapper.type"
import Icon from "src/shared/icons"
const Wrapper = ({
    children,
    bgColor = "var(--white)",
    alertBgColor1,
    alertBgColor2,
    hasIncidences,
    className,
    style,
}: WrapperProps) => {
    const isFirstColor = useToggleFlag()

    return (
        <div
            className={`room-card--xs__wrapper ${className || ""}`}
            style={{
                backgroundColor:
                    alertBgColor1 && alertBgColor2 ? (isFirstColor ? alertBgColor1 : alertBgColor2) : bgColor,
                ...style,
            }}
        >
            {children}
            {!!hasIncidences && (
                <div className="triangle-border up">
                    <Icon
                        name="Exclamation"
                        color="white"
                        width={20}
                        height={20}
                        style={{
                            position: "relative",
                            left: -17,
                            marginTop: 4,
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default Wrapper
